import {
  alpha,
  Dialog,
  DialogActions,
  DialogContent,
  styled,
  Typography,
} from '@mui/material';

import { Button } from 'theSource/components';

export const DIALOG_Z_INDEX = 1450;

export const DialogStyled = styled(Dialog)(({ theme }) => ({
  zIndex: DIALOG_Z_INDEX,
  '.MuiDialog-container': {
    position: 'absolute',
    left: 0,
    bottom: 0,
    minWidth: '100%',
    minHeight: `${theme.customSizes.nativeAuthDialogHeight}rem`,
    maxHeight: `${theme.customSizes.nativeAuthDialogHeight}rem`,
  },
  '.MuiPaper-root': {
    margin: 0,
    padding: theme.spacing(8, 6),
    backgroundColor: theme.palette.primaryDark.main,
    color: theme.palette.common.white,
  },
}));

export const DialogActionsStyled = styled(DialogActions)({
  padding: 0,
});

export const DialogContentStyled = styled(DialogContent)({
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
});

export const CancelButtonStyled = styled(Button)(({ theme }) => ({
  color: theme.palette.primaryMedium.main,
  '&:focus': {
    backgroundColor: alpha(theme.palette.primaryMedium.main, 0.2),
  },
  '.MuiTouchRipple-child': {
    backgroundColor: alpha(theme.palette.primaryMedium.main, 0.2),
  },
}));

export const DialogTitleStyled = styled(Typography)(({ theme }) => ({
  textAlign: 'center',
  height: '6.2rem',
  wordBreak: 'break-word',
  color: theme.palette.common.white,
}));
